export default "__VITE_ASSET__92b1f8ad__"